/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-06-29 10:55:47
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title4 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';

class P10 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  render() {
    const { chartTitle, chartList, chartColorList } = this.state;
    return (
      <Stage>
        <Title4 pageNumber="2.5">安踏VS竞品 | 特定平台传播引爆力效果分析</Title4>

        <div className={s.content}>
          <div contentEditable className={s.subTitle}>安踏在新闻媒体<span className={s.hiht}>（除中央媒体外）</span>、微信号、抖音上排名第一，中央媒体上仅次于李宁</div>
          <div contentEditable className={s.des}>
          对安踏与竞品各自的引爆力内容进行对比分析：①李宁的头部内容在中央媒体上发力比较强势，排名第一，安踏紧随其后；②安踏在新闻媒体、微信号和抖音上表现较好，引爆力内容的数字品牌价值均高于竞品；③安踏和竞品的头部内容较少来自小红书平台。%
          </div>

          <div className={s.chartWrapper}>
            <TooltipDrawer
              style={{ width: '100%', height: '100%' }}
              formContent={<Form onChange={values => this.setState({ ...values })} />}>
              <Chart options={setChart({ label: chartTitle, list: chartList, color: chartColorList })} />
            </TooltipDrawer>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P10);



// WEBPACK FOOTER //
// src/routes/visualChart/P10/index.js